import { useContext } from 'react';
import { ProgressContext } from '../../context/ProgressProvider';
import LinearProgress from '@mui/material/LinearProgress';

function Progress() {
    const { isLoading } = useContext(ProgressContext);

    return (
        <>
            {isLoading && <LinearProgress color='secondary' />}
        </>
    );
}

export default Progress;